export const basenames = {
    form: '/form'
};

export const appBaseName = (() => {
    const [, firstPathName] = window.location.pathname.split('/');
    const baseName = basenames[firstPathName] ?? basenames.promotions;
    return baseName;
})();
